<template>
  <div
    class="fare-option-container box"
    style="border: 1px solid #e3e2e2;width:300px"
  >
    <h3 class="is-size-5 has-text-bold">{{ fareDescription }}</h3>

    <div class="is-size-5 has-text-grey">
      {{ offer.pricing.total | formatPriceFromDollars }}
    </div>

    <hr />
    <div v-if="isRefundable" class="is-size-7 has-text-success has-text-bold">
      <b-icon icon="check-circle" size="is-small" type="is-success" />
      REFUNDABLE
    </div>
    <h3 class="is-size-7 has-text-success" v-if="firstJourney.baggage">
      <b-icon icon="bag-suitcase" size="is-small" />
      {{ firstJourney.baggage.text }} <span v-if="firstJourney.baggage.qty">: {{ firstJourney.baggage.qty }}</span>
    </h3>
    <div
      v-for="(service, serviceIndex) in services"
      :key="serviceIndex"
    >
      <FareFamilyService :service="service" />
    </div>
    <div class="is-size-7">
      <b-icon icon="information" size="is-small" />
      Fare Rules:
      <span v-if="fareDetails.endorsements.length == 0"> None</span>
      <span
        v-for="(endorsement, eIndex) in fareDetails.endorsements"
        :key="eIndex"
      >
        {{ endorsement }}
      </span>
    </div>
    <hr />

    <div ref="journeyList" class="columns is-multiline is-mobile">
      <div v-for="journey in journeyList" :key="journey.id" class="column">
        <div class="columns is-gapless is-mobile mb-0">
          <div class="column is-narrow mr-2">
            <div class="has-text-weight-bold">{{ journey.origin }}</div>
          </div>
          <div class="column is-narrow mr-2">
            <span class="is-size-7 mt-1 is-block"
              ><span class="icon has-text-grey-light is-small"
                ><i class="mdi mdi-arrow-right"></i></span
            ></span>
          </div>
          <div class="column is-narrow mr-2">
            <div class="has-text-weight-bold">{{ journey.destination }}</div>
          </div>
          <!---->
        </div>
        <h3 class="is-size-7 has-text-bold">{{ journey.bookingClass }}</h3>
      </div>
    </div>

    <div
      v-if="
        solution.isSelectable &&
          solution.immediateTravelBookingAdvice != 'prevent'
      "
      class="is-inline-block is-clickable"
      style="width: 140px;"
    >
      <b-button type="is-primary" expanded @click="checkSubmission()"
        >Book</b-button
      >
    </div>
    <div
      v-if="!solution.isSelectable"
      class="mt-4 is-size-7 has-text-grey is-block"
    >
      Not selectable
    </div>

    <div
      v-if="
        solution.isSelectable &&
          solution.immediateTravelBookingAdvice == 'prevent'
      "
      class="mt-4 notification is-size-7 has-text-grey has-text-centered"
    >
      To book this option call: <br />
      877-924-0303
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
import FareFamilyService from "./FareFamilyService.vue";
import AddMeetingGuest from "../../Meetings/AddMeetingGuest.vue";

export default {
  name: "NDCFareOption",
  mixins: [bookingMixin],
  props: {
    solution: Object,
    offer: Object,
  },
  components: {
    FareFamilyService,
  },
  data: function() {
    return {};
  },
  computed: {
    offerInfo() {
      return this.offer;
    },
    isRefundable() {
      //Show refundable if fareDetails.refundable is true or if the fareDetails.endorsements contains the word "refundable"
      return (
        this.fareDetails.refundable ||
        this.fareDetails.endorsements.findIndex(
          (endorsement) => endorsement.toUpperCase() == "REFUNDABLE"
        ) > -1
      );
    },
    journeyList() {
      return this.offer.journeyList;
    },
    fareDescription() {
      //Get the booking class from the first journey
      return this.firstJourney.bookingClass;
    },
    fareDetails() {
      //Fare rules are included per segment, so we just show the first segment's fare rules
      return this.offer.fareRules[0];
    },
    services() {
      //Show any services that are included in the fare
      let services = this.offer.services.filter(
        (service) => service?.status == "included"
      );
      //Remove duplicates
      return [...new Map(services.map((m) => [m.description, m])).values()];
    },
    firstJourney() {
      return this.offer.journeyList[0];
    },
  },
  methods: {
    checkSubmission() {
      // console.log('checkSubmission', sol);

      if (this.solution.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a flight with a departure time in the next few hours. Please watch your email for your Final Ticketed Itinerary.  If you do not receive your Final Ticketed Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.   ",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.submit(),
        });
      } else {
        this.submit();
      }
    },
    submit() {
      //hide the Fare Options modal
      //this.$store.commit("bookTravel/HIDE_FARE_OPTIONS");

      let payload = {
        flight: this.solution,
        selectedOffer: this.offer,
      };

      this.$store.commit("bookTravel/SET_NDC_BOOKING", payload);

      if (this.pathMixin_isMeeting) {
        this.meetingRouter();

        if (this.meetingInfo.allowedToBringGuest) {
          this.$buefy.modal.open({
            parent: this,
            component: AddMeetingGuest,
            props: {},
            hasModalCard: true,
            trapFocus: true,
            width: 650,
          });
        }
      } else {
        this.$nav.pushRouteTo({ name: "NdcCheckout" });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
